import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0acaf02e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0acaf02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acaf02e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acaf02e')) {
      api.createRecord('0acaf02e', component.options)
    } else {
      api.reload('0acaf02e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0acaf02e&scoped=true&", function () {
      api.rerender('0acaf02e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deposit/payment/index.vue"
export default component.exports